import React from 'react';
import {
  Text,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from 'ui';
import { jsx, tscope } from '@i18n/index';
import { WhatsAppIcon } from '@assets/icons';
import { ts } from './utils';
import { style as s } from './MissingDocumentModal.style';
import { useController } from './hooks';
import { CancelRequisitionModal } from '../CancelRequisitionModal';

const t = tscope('Common.brand');

export const MissingDocumentModal = (props) => {
  const {
    type,
    isOpen,
    onClose,
  } = props;

  const {
    isVIP,
    isCancelOpen,
    onCancelOpen,
    onCancelClose,
    requisitionStatus,
  } = useController({
    onClose,
  });

  return (
    <>
      <CancelRequisitionModal
        isOpen={isCancelOpen}
        onClose={onCancelClose}
        requisitionStatus={requisitionStatus}
      />
      <Modal
        size="sm"
        isCentered
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text {...s.title} data-testid="title">
              {jsx('title', {
                t: ts,
                documentType: (
                  <Text as="span">
                    {ts(`${type}`)}
                  </Text>
                ),
              })}
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <Divider />
          <ModalBody {...s.body}>
            <Text {...s.centerText} data-testid="body1">
              {jsx('body1', {
                t: ts,
                essential: (
                  <Text as="span" {...s.bold}>
                    {ts('essential')}
                  </Text>
                ),
              })}
            </Text>
            <Text {...s.bold}>
              {ts('body2')}
            </Text>
            {
              isVIP
                ? (
                  <Button
                    leftIcon={<WhatsAppIcon boxSize="7" color="white" />}
                    {...s.button}
                    as="a"
                    href={t(
                      'whatsAppMe',
                      { number: t('whatsAppDocumentsNumber'), text: t('whatsAppVIPDocumentsTextPlain') },
                    )}
                    target="_blank"
                    colorScheme="green"
                    data-testid="whatsapp-button"
                  >
                    {ts('contactsAdvisor')}
                  </Button>
                )
                : (
                  <Button
                    variant="outline"
                    {...s.button}
                    onClick={onClose}
                  >
                    {ts('illGetIt')}
                  </Button>
                )
            }
            <Button
              variant="ghost"
              colorScheme="red"
              {...s.button}
              onClick={onCancelOpen}
            >
              {ts('cancel')}
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
